<template>
 <v-container>
    <v-card color="oug"
      class="pa-1 mx-auto text-center justify-center"
      max-width="600"
      elevation="24">
      <v-card-title class="text-h6 white--text">Help</v-card-title>
      <v-expansion-panels focusable>
        <v-expansion-panel>
          <v-expansion-panel-header
            >What is the BQ Referee's App</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            The BQ Referee's App is a resource for referees in Queensland to
            find out details about the Referee Accreditation pathway, including
            information such as how to advance to the next level, what rewards
            come with advancing, contact details of key people in Queensland for
            Referees, and rosources such as documents, videos and links to
            online courses. The BQ Refee's app also features communication
            features so you can contact any of the key people directly through
            the app.
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            >How Can I Find Out More Information</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            You can find out more information by contacting the Basketball Queensland Referee Development Manager. Their
            contact details can be found in the 'People' page in the App.
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            >Why Can I Not View Some Screens Inside the
            App?</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            To view some of the personal screens (such as documents, videos and
            accreditation details), you will need to login to the BQ Referee's
            App. You can do so by pressing the icon up the top right hand corner
            of your device, and then by pressing 'Login'. You just have to enter
            you BQ Login username and password and login to gain access.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <p></p>
    <Zendesk class="mb-3" title="Need Additional Help ?"/>
  </v-container>
</template>

<script>
import Zendesk from "../common/Zendesk";

export default {
  components: {
    Zendesk,
  },
  methods: { },
};

</script>

<style>
</style>